import React from 'react'

export default function CompanyDoesNotExist() {
  return (
    <div>
      Company does not exist
    </div>
  )
}
